<template>
    <div class="materials-template">
        <Row type="flex" justify="space-between" align="middle">
            <div class="title-l">
                <router-link to="/index/materials-price" class="span-box">
                    <Icon type="ios-arrow-back" />
                    <span>询价单管理-模板创建</span>
                </router-link>
            </div>
        </Row>
        <div class="table-title">
            <h5>选择物资</h5>
            <Row type="flex" justify="space-between">
                <Row type="flex">
                    <div class="boxs-div">
                        <span class="input-label">物资分类：</span>
                        <span class="Cascader">
                            <Cascader
                                :data="productClassifyData"
                                v-model="productClassify"
                                @on-change="productClassifyChange"></Cascader>
                        </span>
                    </div>
                    <div class="boxs-div">
                        <span class="input-label">物资名称：</span>
                        <span class="Cascader">
                            <Input placeholder="物资名称"
                                v-model="productByClassifyVar.productName"/>
                        </span>
                        <Button
                            type="primary"
                            @click="getProduct">
                            搜索
                        </Button>
                    </div>
                </Row>
                <Button type="primary" :loading="checkLoading" @click="addMultipleTerm">添加全部物资</Button>
            </Row>
        </div>
        <Row>
            <div :span="12">
                <Table
                    :columns="columns"
                    :data="leftData"
                    :height="350"
                    @on-selection-change="getLeftSelectionChange"
                    ref="leftData">
                    <template slot-scope="{ row }" slot="action">
                        <Button size="small" @click="addRightData(row)" v-if="!row._disabled">添加</Button>
                        <Button size="small" v-else>已添加</Button>
                    </template>
                </Table>
                <div class="pages-footer">
                    <Page
                        :current="productByClassifyVar.pageNumber"
                        :total="leftTotal"
                        :page-size="productByClassifyVar.pageSize"
                        @on-change="getLeftChangePageNum"/>
                </div>
            </div>
            <div>
                <h5>模板创建</h5>
                <Row class="table-title-r" type="flex" justify="space-between">
                    <span class="import-model-span">
                        <Button type="primary">引用历史询价单</Button>
                        <input type="file" name="files" class="import-input" @change="importHistory">
                    </span>
                    <!-- <Button @click="removeMultipleTerm">批量删除</Button> -->
                </Row>
                <Table
                    :columns="columns"
                    :data="rightSectionData"
                    :height="450"
                    @on-selection-change="getRightSelectionChange">
                    <template slot-scope="{ row }" slot="action">
                        <Button @click="removeRightItems(row)" size="small">移除</Button>
                    </template>
                </Table>
            </div>
        </Row>
        <div class="export-button">
            <Button type="primary" :loading="downLoading" @click="exportTemplate">导出模板</Button>
        </div>
        <Table :columns="columns12" :data="tableContents" id="Tool-test"></Table>
    </div>
</template>

<script>
import { queryProductClassify, queryProductByClassifyNo } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import { creatMultidimensionalArray } from '@/assets/js/creatArr.js';
import XLSX from 'xlsx';
import factory from '@/assets/js/ybTool.js';
import '@/assets/js/query.min.js';
import '@/assets/js/jszip.min.js';
export default {
    data() {
        return {
            productClassifyData: [],
            productClassify: [],
            productByClassifyVar: {
                pageNumber: 1,
                pageSize: 40,
                classifyNo: '',
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                productName: ''
            },
            columns: [
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 100
                },
                {
                    title: '物资编码',
                    key: 'productno',
                    minWidth: 100
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '物资描述',
                    key: 'productspec',
                    minWidth: 80
                },
                {
                    title: '分类名称',
                    key: 'classifyname',
                    minWidth: 100
                },
                {
                    title: '分类编码',
                    key: 'productno',
                    minWidth: 90
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    minWidth: 80
                }
            ],
            leftData: [],
            leftTotal: 0,
            rightData: [],
            rightSectionData: [],
            rightPages: {
                pageNumber: 1,
                pageSize: 40
            },
            leftSelectOptions: [],
            rightSelectOptions: [],
            downLoading: false,
            tableContents: [],
            columns12: [
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 150
                },
                {
                    title: '物资编码',
                    key: 'productno',
                    minWidth: 150
                },
                {
                    title: '分类名称',
                    key: 'classifyname',
                    minWidth: 100
                },
                {
                    title: '分类编码',
                    key: 'classifyno',
                    minWidth: 100,
                    className: 'td-text'
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '物资描述',
                    key: 'productspec',
                    minWidth: 100
                },
                {
                    title: '单价（元）',
                    key: 'unitPrice',
                    minWidth: 100
                }
            ],
            allProductList: [],
            checkLoading: false
        };
    },
    watch: {
        rightData: {
            handler() {
                this.getAllTableChange();
                this.setRightTablePages();
            },
            deep: true
        },

        rightPages: {
            handler() {
                this.setRightTablePages();
            },
            deep: true
        },

        leftData: {
            handler() {
                this.getAllTableChange();
            },
            deep: true
        },

        productByClassifyVar: {
            handler() {
                this.getProduct();
            },
            deep: true
        },

        productClassify(val) {
            this.productByClassifyVar.pageNumber = 1;
        },

        productName(val) {
            if (val) {
                this.productClassify = [];
                this.productByClassifyVar.classifyNo = '';
            }
        }
    },
    mounted() {
        this.getProductClassify();
        this.getProduct();
    },
    methods: {
        exportTemplate() {
            if (!this.rightData.length) {
                this.$setNotice('暂无数据要导出');
            } else {
                this.downLoading = true;
                this.tableContents = this.rightData;
                setTimeout(() => {
                    document.querySelector('#Tool-test .ivu-table-tip tbody td span').innerText = ' ';
                    factory().excelExport({
                        'src_id': 'Tool-test',
                        'type': 'table',
                        'show_header': true
                    }, '询价单模板');
                    this.downLoading = false;
                }, 1000);
            }
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                return v[j];
            }));
        },
        importHistory(ev) {
            let file = ev.target.files[0];
            const _self = this;
            if (!file) {
                this.$setNotice('模板上传失败');
                return;
            }
            let reader = new FileReader();
            reader.onload = function(e) {
                let data = e.target.result;
                let workbook = XLSX.read(data, {
                    type: 'binary'
                });
                _self.process_wb(workbook);
            };
            reader.readAsBinaryString(file);
            ev.target.value = '';
        },
        process_wb(workbook) {
            let modelArr = '';
            modelArr = JSON.parse(this.to_json(workbook)).Sheet1;
            if (!modelArr || (modelArr.length && modelArr[0][7] !== '单价（元）')) {
                this.$setNotice('请上传标准模板');
                return;
            }
            let tableHead = modelArr.splice(0, 1);
            let temporaryArr = [];
            modelArr.forEach(ele => {
                if (ele[2]) {
                    temporaryArr.push({
                        productname: ele[1],
                        productspectype: ele[5],
                        productspec: ele[6],
                        classifyname: ele[3],
                        productno: ele[2],
                        productspu: ele[4]
                    });
                }
            });
            this.rightData = this.rightData.concat(temporaryArr);
        },
        to_json(workbook) {
            let result = {};
            workbook.SheetNames.forEach(sheetName => {
                var roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
                    header: 1
                });
                if (roa.length) result[sheetName] = roa;
            });
            return JSON.stringify(result, 2, 2);
        },
        addRightData(rows) {
            if (this.leftSelectOptions.length) {
                this.$refs.leftData.selectAll(false);
            }
            let addItem = Object.assign({}, this.leftData[rows._index]);
            this.leftData[rows._index]._disabled = true;
            this.rightData.push(addItem);
        },
        // 选中所有物资
        addMultipleTerm() {
            if (this.leftData.length) {
                let queryVars = {
                    currentPage: 1,
                    pageSize: 500
                };
                let len = 0;
                this.allProductList = [];
                this.rightData = [];
                this.getAllProduct(queryVars, len);
            } else {
                this.$setNotice('没有要选择的物资');
            }
        },
        getAllProduct(qur, len) {
            this.checkLoading = true;
            this.$apollo.query({
                query: queryProductByClassifyNo,
                variables: {
                    classifyNo: '',
                    productName: '',
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    pageNumber: qur.currentPage,
                    pageSize: qur.pageSize
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductByClassifyNo;
                if (data && data.data && data.code === 200) {
                    this.allProductList = this.allProductList.concat(data.data);
                    let len1 = Math.ceil(data.count / 500);
                    if (qur.currentPage < len1) {
                        qur.currentPage += 1;
                        this.getAllProduct(qur, len1);
                    } else {
                        if (this.allProductList.length) {
                            this.checkLoading = false;
                            this.rightData = this.allProductList;
                            this.$setNotice('添加成功');
                        } else {
                            this.$setNotice('物资列表获取失败，刷新试试吧');
                            this.checkLoading = false;
                        }
                    }
                } else {
                    this.$setNotice('物资列表获取失败，刷新试试吧');
                }
            });
        },
        setRightTablePages() {
            this.rightSectionData = this.rightData;
        },
        removeRightItems(rows) {
            this.rightData.splice(rows._index, 1);
        },
        removeMultipleTerm() {
            if (this.rightSelectOptions.length) {
                this.rightSelectOptions.forEach(ele => {
                    let rightIndex = this.rightData.findIndex(term => term.productno === ele.productno);
                    this.rightData.splice(rightIndex, 1);
                });
            } else {
                this.$setNotice('没有要删除的物资');
            }
        },
        getAllTableChange() {
            this.leftData.forEach(ele => {
                let leftIndex = this.rightData.findIndex(item => {
                    return item.productno === ele.productno && item.productspectype === ele.productspectype;
                });
                if (leftIndex !== -1) {
                    ele._disabled = true;
                } else {
                    ele._disabled = false;
                }
            });
        },
        getLeftSelectionChange(selects) {
            this.leftSelectOptions = selects;
        },
        getRightSelectionChange(selects) {
            this.rightSelectOptions = selects;
        },
        productClassifyChange(val) {
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.classifyNo = val[val.length - 1] || '';
        },
        getProductClassify() {
            this.$apollo.query({
                query: queryProductClassify,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductClassify;
                if (data && data.data && data.code === 200) {
                    let parentData = [];
                    for (let i = 5;i > 0;i -= 1) {
                        if (data.data[i.toString()].length) {
                            parentData = creatMultidimensionalArray(
                                data.data[i.toString()],
                                parentData,
                                'classifyParentNo',
                                'classifyName',
                                'classifyNo'
                            );
                        } else {
                            continue;
                        }
                    }
                    parentData.forEach(ele => {
                        let classifyName, classifyNo, children, value, label;
                        ({ classifyName: label, classifyNo: value, children } = ele);
                        this.productClassifyData.push({
                            value,
                            label,
                            children
                        });
                    });
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        },
        getProduct() {
            this.$apollo.query({
                query: queryProductByClassifyNo,
                variables: this.productByClassifyVar,
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductByClassifyNo;
                if (data && data.data && data.code === 200) {
                    this.$Notice.destroy();
                    data.data.forEach(ele => {
                        ele._disabled = false;
                    });
                    this.leftTotal = data.count;
                    this.leftData = data.data;
                } else {
                    this.$setNotice('物资列表获取失败，刷新试试吧');
                }
            });
        },
        getLeftChangePageNum(val) {
            this.productByClassifyVar.pageNumber = val;
        }
    }
};
</script>

<style lang="stylus" scoped>
.title-l
    padding-bottom: 10px;
h5
    padding: 10px;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    background: #f8f8f9;
    font-weight: 600;
    margin-bottom: 10px;
.boxs-div+.boxs-div
    margin-left: 20px;
.table-title
    padding: 10px 0;
.table-title-r
    margin-bottom: 8px;
.pages-footer
    text-align: center;
    padding: 16px 0;
.export-button
    text-align: center;
    padding: 40px 0;
    button
        padding: 10px 60px;
#Tool-test
    position: fixed;
    left: 0;
    top: 0;
    z-index: -999;
    opacity: 0;
.import-model-span
    position: relative;

    .import-input
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        color: transparent;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        z-index: 5;
        text-indent: 999999999px;
        cursor: pointer;
        outline: none;

    button
        position: relative;
        z-index: 3;
        border: none;
</style>



// WEBPACK FOOTER //
// src/views/materialsPrice/TemplateCreate.vue